import React, { useState } from 'react';
import { Wrapper } from './Scroller.styles';
import { LongContent } from './LongContent';

export const Scroller = ({ children }) => {
    const [scrollLeftTo, setScrollLeftTo] = useState(0);

    const handleSetScroll = (newScrollLeftTo) => {
        setScrollLeftTo(newScrollLeftTo);
    };

    return (
        <Wrapper>
            <LongContent handleSetScroll={handleSetScroll} scrollLeftTo={scrollLeftTo}>
                {children}
            </LongContent>
        </Wrapper>
    );

    /*
    TODO: Should animate scrolling on button click, 
    but sometimes there is problem with button scrolling and 
    manual scrolling back, Motion does not always know that user scrolled back.
    
    Uncomment the following block to add the animation logic with Motion.

    return (
        <Wrapper>
            <Motion style={{ scrollLeftTo: spring(scrollLeftTo, presets.noWobble) }}>
                {(currentStyles) => (
                    <LongContent
                        handleSetScroll={handleSetScroll}
                        scrollLeftTo={currentStyles.scrollLeftTo}
                    >
                        {children}
                    </LongContent>
                )}
            </Motion>
        </Wrapper>
    );
    */
};
